export const ORDER_UPLOAD_TERMINAL_STAGES = [
  "validation_failed",
  "ukho_errors",
  "fulfilled",
  "failed",
] as const;

export const isOrderUploadTerminal = (stage?: string): boolean =>
  !!stage && (ORDER_UPLOAD_TERMINAL_STAGES as readonly string[]).includes(stage);

export const ORDER_UPLOAD_STAGE_LABELS: Record<string, string> = {
  uploaded: "Uploaded",
  processing: "Processing",
  validating: "Validating",
  submitting_to_ukho: "Submitting to UKHO",
  issuing_permits: "Issuing permits",
  validation_failed: "Validation failed",
  ukho_errors: "UKHO errors",
  fulfilled: "Fulfilled",
  failed: "Failed",
};
